import {
  SensorReadingBase,
  SensorType,
  useGetSensorRollupByTypeDays as useGetSensorRollupByTypeCommon,
  SensorDataProvider,
} from 'common';

import { useAppSync } from '../../contexts/AppSyncContext';

export const useGetSensorRollupByType = <T extends SensorReadingBase>(
  sensorType: SensorType | SensorType[],
  days: number = 7,
  rollupInSeconds?: number,
) => {
  const { sensors, selectedHubId, sensorsLoading } = useAppSync();
  const dataProvider: SensorDataProvider = {
    sensors,
    selectedHubId,
    sensorsLoading: !!sensorsLoading,
  };
  return useGetSensorRollupByTypeCommon<T>(sensorType, days, dataProvider, rollupInSeconds);
};
